import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize32 {
  size: '32';
}
type OverrideIconSize = OverrideIconSize32;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '32') {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2ZM23.8447 14.5055C23.2688 13.8088 22.1783 13.8088 21.4783 14.3061C20.3326 15.0964 20.1793 16.9718 21.1904 17.9277C21.9182 18.6167 23.1356 18.5971 23.8593 17.9108L23.8408 18.1731C23.8159 18.4835 23.7646 18.8001 23.5339 19.0237C23.3334 19.2133 23.0607 19.2515 22.7929 19.2651L22.5296 19.2751C22.531 19.7214 22.5328 20.1667 22.531 20.613C23.1762 20.6417 23.8793 20.597 24.4132 20.1918C25.0283 19.7387 25.2884 18.9466 25.2943 18.2079V14.1072C24.8097 14.1026 24.3251 14.1026 23.8419 14.1072L23.8447 14.5055ZM19.1431 14.6293C18.4431 13.9608 17.3699 13.8221 16.4642 14.0772C15.188 14.3833 14.4953 15.8909 14.9972 17.0809C15.589 18.6008 17.7505 18.902 18.9701 17.978C20.0087 17.2128 20.0776 15.5022 19.1431 14.6293ZM6.52601 12.1419C6.47536 14.2089 6.5219 16.2795 6.5 18.3484C6.98732 18.368 7.47646 18.363 7.96424 18.3584L7.95511 17.9204C8.56289 18.6856 9.77936 18.65 10.4825 18.0408C11.5096 17.1807 11.5429 15.4231 10.5838 14.5C9.88933 13.7982 8.64822 13.7686 7.94553 14.4749C7.97245 13.7024 7.9469 12.9281 7.96424 12.1561C7.48513 12.1506 7.00648 12.1561 6.52601 12.1419ZM11.7365 12C11.7338 12.4773 11.7279 12.9532 11.7365 13.43C12.1737 13.5564 12.4023 13.989 12.3991 14.4224C12.4543 15.7338 12.405 17.0479 12.4269 18.3598C12.906 18.363 13.3856 18.363 13.866 18.3584L13.8692 14.4224C13.8847 13.6641 13.6187 12.845 12.9863 12.3833C12.6309 12.1109 12.1796 12.0137 11.7365 12ZM8.473 15.346C9.07348 15.064 9.82727 15.575 9.76339 16.2408C9.81997 16.9257 9.00686 17.4052 8.41825 17.0922C7.70917 16.7824 7.74385 15.6042 8.473 15.346ZM17.0213 15.3206C17.6099 15.0952 18.319 15.6085 18.2405 16.2464C18.319 16.9495 17.4452 17.4227 16.8621 17.0718C16.1603 16.7246 16.2616 15.5318 17.0213 15.3206ZM22.6122 15.3054C23.22 15.0202 23.972 15.5769 23.8939 16.2408C23.9259 16.9394 23.0808 17.3647 22.5009 17.0361C21.8283 16.698 21.8949 15.5527 22.6122 15.3054Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 32 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'blog');
export default IconComponent;
